import React from "react";
import { SearchesActions } from "./SearchesActions";
import { SearchSelected } from "./SearchSelected";
import useSearches from "./useSearches";

interface SearchesProps {
	namespace: string;
	label: string;
}

export function Searches({ namespace, label }: SearchesProps) {
	const { current, searchDirty, updateSearch } = useSearches(namespace);

	return (
		<>
			<SearchSelected current={current} label={label} />
			<SearchesActions
				current={current}
				searchDirty={searchDirty}
				updateSearch={updateSearch}
			/>
		</>
	);
}
